import Model from './Model';

export default class BoardModel extends Model {
  id: number;
  title: string;
  description: string;

  static __typename: string = "Board";

  constructor(board: any, getters: any) {
    super(getters);
    this.id = board.id;
    this.title = board.title;
    this.description = board.description;
  }
}